'use client';

import { useCallback, useMemo, useState, type ReactNode } from 'react';

import {
  AuthorLevelsApplicationContext,
  type AuthorLevelId,
} from '@/features/original-plus/context/author-levels-application-context';
import { authorLevels, originalPlusApplicationFormId } from '@/features/original-plus/constants';

export function AuthorLevelsApplicationProvider({ children }: { children: ReactNode }) {
  const [selectedLevelId, setSelectedLevelIdState] = useState<AuthorLevelId>(authorLevels[0].id);
  const [wantsConsultation, setWantsConsultation] = useState(false);

  const setSelectedLevelId = useCallback((id: AuthorLevelId) => {
    setSelectedLevelIdState(id);
    setWantsConsultation(false);
  }, []);

  const applyForLevel = useCallback(
    (id: AuthorLevelId) => {
      setSelectedLevelId(id);

      requestAnimationFrame(() => {
        const formEl = document.getElementById(originalPlusApplicationFormId);
        formEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    [setSelectedLevelId],
  );

  const value = useMemo(
    () => ({
      selectedLevelId,
      setSelectedLevelId,
      wantsConsultation,
      setWantsConsultation,
      applyForLevel,
    }),
    [selectedLevelId, setSelectedLevelId, wantsConsultation, applyForLevel],
  );

  return (
    <AuthorLevelsApplicationContext.Provider value={value}>
      {children}
    </AuthorLevelsApplicationContext.Provider>
  );
}
